// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B6ugKYovLxod3Xbwv4qs{border:1px solid var(--border-neutral-default);min-height:40px;color:var(--content-primary-tertiary);border-radius:6px;justify-content:space-between;align-items:center;gap:4px;padding:11px;display:flex}.HU6KukiJdkAKJd64_v04{align-items:center;gap:6px;display:flex}.pLBrTL3fzR821DERgYrG{color:var(--content-neutral-primary);cursor:pointer;align-items:center;display:inline-flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleRow": `B6ugKYovLxod3Xbwv4qs`,
	"label": `HU6KukiJdkAKJd64_v04`,
	"tooltipIcon": `pLBrTL3fzR821DERgYrG`
};
export default ___CSS_LOADER_EXPORT___;
